export default __webpack_public_path__ + "static/media/logo.7867269a.svg";